import React from 'react';
import { Grid, Typography, TextField, Box, Button, Slider } from '@mui/material';

const SettingsTab = ({ userSettings, setUserSettings, updateUserSettings }) => {
    if (!userSettings) return <Typography>Loading settings...</Typography>;

    const updateNestedSetting = (category, key, value) => {
        const updated = { ...userSettings };
        updated[category][key] = value;
        setUserSettings(updated);
    };

    return (
        <Box>
            <Typography variant="h6" gutterBottom>Calculation Settings</Typography>
            <Grid container spacing={3}>
                {/* Harvesting Settings */}
                <Grid item xs={12}>
                    <Typography variant="subtitle2" color="primary" fontWeight="bold">Harvesting (Final Felling)</Typography>
                </Grid>
                <Grid item xs={6}>
                    <TextField 
                        label="Timber Price (SEK/m3sk)" 
                        type="number" fullWidth size="small"
                        value={userSettings.harvesting.timber_price_m3sk}
                        onChange={(e) => updateNestedSetting('harvesting', 'timber_price_m3sk', parseInt(e.target.value))}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField 
                        label="Pulpwood Price (SEK/m3sk)" 
                        type="number" fullWidth size="small"
                        value={userSettings.harvesting.pulpwood_price_m3sk}
                        onChange={(e) => updateNestedSetting('harvesting', 'pulpwood_price_m3sk', parseInt(e.target.value))}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="caption">Timber / Pulpwood Split (%)</Typography>
                    <Box display="flex" alignItems="center" gap={2}>
                        <Slider 
                            value={userSettings.harvesting.timber_percentage}
                            onChange={(_, value) => {
                                updateNestedSetting('harvesting', 'timber_percentage', value);
                                updateNestedSetting('harvesting', 'pulpwood_percentage', 100 - value);
                            }}
                            min={0} max={100} valueLabelDisplay="auto"
                        />
                        <Typography variant="body2">{userSettings.harvesting.timber_percentage}% / {userSettings.harvesting.pulpwood_percentage}%</Typography>
                    </Box>
                </Grid>

                <Grid item xs={6}>
                    <TextField 
                        label="GROT Price (SEK/m3s)" 
                        type="number" fullWidth size="small"
                        value={userSettings.harvesting.grot_price_m3s}
                        onChange={(e) => updateNestedSetting('harvesting', 'grot_price_m3s', parseInt(e.target.value))}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField 
                        label="GROT Factor (m3s/m3sk)" 
                        type="number" fullWidth size="small"
                        value={userSettings.harvesting.grot_factor}
                        onChange={(e) => updateNestedSetting('harvesting', 'grot_factor', parseFloat(e.target.value))}
                    />
                </Grid>

                {/* Operations */}
                <Grid item xs={12}>
                    <Typography variant="subtitle2" color="primary" fontWeight="bold" sx={{ mt: 1 }}>Operations</Typography>
                </Grid>
                <Grid item xs={6}>
                    <TextField 
                        label="Machine Rate (SEK/hr)" 
                        type="number" fullWidth size="small"
                        value={userSettings.operations.hourly_machine_rate}
                        onChange={(e) => updateNestedSetting('operations', 'hourly_machine_rate', parseInt(e.target.value))}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField 
                        label="Felling Start Cost (SEK)" 
                        type="number" fullWidth size="small"
                        value={userSettings.operations.felling_start_cost}
                        onChange={(e) => updateNestedSetting('operations', 'felling_start_cost', parseInt(e.target.value))}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField 
                        label="Felling hr/ha" 
                        type="number" fullWidth size="small"
                        value={userSettings.operations.felling_hours_per_ha}
                        onChange={(e) => updateNestedSetting('operations', 'felling_hours_per_ha', parseFloat(e.target.value))}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField 
                        label="Clearing SEK/ha" 
                        type="number" fullWidth size="small"
                        value={userSettings.operations.clearing_rate_per_ha}
                        onChange={(e) => updateNestedSetting('operations', 'clearing_rate_per_ha', parseInt(e.target.value))}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField 
                        label="Thinning hr/ha" 
                        type="number" fullWidth size="small"
                        value={userSettings.operations.thinning_hours_per_ha}
                        onChange={(e) => updateNestedSetting('operations', 'thinning_hours_per_ha', parseFloat(e.target.value))}
                    />
                </Grid>
                <Grid item xs={4}>
                    <TextField 
                        label="Thinning Start Cost" 
                        type="number" fullWidth size="small"
                        value={userSettings.operations.thinning_start_cost}
                        onChange={(e) => updateNestedSetting('operations', 'thinning_start_cost', parseInt(e.target.value))}
                    />
                </Grid>

                {/* Silviculture */}
                <Grid item xs={12}>
                    <Typography variant="subtitle2" color="primary" fontWeight="bold" sx={{ mt: 1 }}>Silviculture</Typography>
                </Grid>
                <Grid item xs={6}>
                    <TextField 
                        label="Plants Density (per ha)" 
                        type="number" fullWidth size="small"
                        value={userSettings.silviculture.planting_density_per_ha}
                        onChange={(e) => updateNestedSetting('silviculture', 'planting_density_per_ha', parseInt(e.target.value))}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField 
                        label="Cost per Plant" 
                        type="number" fullWidth size="small"
                        value={userSettings.silviculture.cost_per_plant}
                        onChange={(e) => updateNestedSetting('silviculture', 'cost_per_plant', parseFloat(e.target.value))}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Button
                        variant="contained"
                        fullWidth
                        sx={{ mt: 2 }}
                        onClick={() => updateUserSettings(userSettings)}
                    >
                        Save Settings
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default SettingsTab;
